"use strict";

exports.__esModule = true;
exports.autoResize = void 0;
var _autoResize = require("./autoResize");
exports.autoResize = _autoResize.autoResize;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/3rdparty/autoResize/index.js
// module id = 1012
// module chunks = 0